export const CLEARANCE_SCHEMA = [
  {
    name: 'ha',
    ua_name: 'HA',
    eng_name: 'HA',
    children: [
      {
        name: 'general',
        ua_name: 'Загальна інформація',
        eng_name: 'General Information',
        children: [
          { name: 'imsma_id', ua_name: 'Ідентифікаційний номер IMSMA', eng_name: 'IMSMA ID' },
          { name: 'hazard_name', ua_name: 'Назва небезпечної території', eng_name: 'Hazard name' },
          { name: 'internal_id', ua_name: 'Внутрішній ID', eng_name: 'Internal ID' },
          { name: 'reporter_organization', ua_name: 'Організація', eng_name: 'Reporter organization' },
        ],
      },
      {
        name: 'location',
        ua_name: 'Локація',
        eng_name: 'Location',
        children: [
          { name: 'region', ua_name: 'Область', eng_name: 'Region' },
          { name: 'district', ua_name: 'Район', eng_name: 'District' },
          { name: 'local_community', ua_name: 'Територіальна громада', eng_name: 'Local community' },
          { name: 'settlement_name', ua_name: 'Населений пункт', eng_name: 'Settlement' },
        ],
      },
      {
        name: 'turn_points',
        ua_name: 'Полігон',
        eng_name: 'Polygon',
        children: [
          { name: 'points', ua_name: 'Полігон', eng_name: 'Polygon' },
          { name: 'total_area_meters', ua_name: 'Площа (кв.м)', eng_name: 'Total area (sqm)' },
        ],
      },
    ],
  },
  {
    name: 'gis',
    ua_name: 'GIS',
    eng_name: 'GIS',
    children: [
      { name: 'deminers_polygon', ua_name: 'Полігон саперів', eng_name: 'Deminers polygon' },
      { name: 'deminers_files_links', ua_name: 'Файлова інформація', eng_name: 'File information' },
    ],
  },
  {
    name: 'tcp',
    ua_name: 'TCP',
    eng_name: 'TCP',
    children: [
      { name: 'user', ua_name: 'Хто створив', eng_name: 'Report provided' },
      { name: 'donor', ua_name: 'Донор', eng_name: 'Donor' },
      { name: 'task_customer', ua_name: 'Замовник задачі', eng_name: 'Task customer' },
      { name: 'methods', ua_name: 'Тип методу', eng_name: 'Method Type' },
      { name: 'imsma_id', ua_name: 'Ідентифікаційний номер IMSMA TC', eng_name: 'IMSMA ID TC Plan' },
      { name: 'start_date', ua_name: 'Дата початку', eng_name: 'Start date' },
      { name: 'internal_id', ua_name: 'ID завдання', eng_name: 'Task ID' },
      { name: 'estimate_days', ua_name: 'Очікувана тривалість', eng_name: 'Expected Duration' },
      { name: 'position_user', ua_name: 'Посада', eng_name: 'Reporter position' },
    ],
  },
  {
    name: 'team',
    ua_name: 'Склад команди',
    eng_name: 'Team members',
    children: [
      { name: 'related_users', ua_name: 'Склад команди', eng_name: 'Team' },
    ],
  },
  {
    name: 'files',
    ua_name: 'Файли',
    eng_name: 'Files',
    children: [
      { name: 'files', ua_name: 'Файли', eng_name: 'Files' },
    ],
  },
  {
    name: 'cl_task_id',
    ua_name: 'ID звіту',
    eng_name: 'Report ID in database',
    children: [
      { name: 'id', ua_name: 'ID звіту', eng_name: 'Report ID in database' },
    ],
  },
  {
    name: 'created_at',
    ua_name: 'Дата створення',
    eng_name: 'Created at',
    children: [
      { name: 'created_at', ua_name: 'Дата створення', eng_name: 'Created at' },
    ],
  },
  {
    name: 'progress_map',
    ua_name: 'Progress Map',
    eng_name: 'Progress Map',
    children: [
      { name: 'crosshair', ua_name: 'Точка входу', eng_name: 'Entry point' },
    ],
  },
  {
    name: 'comments_summary',
    ua_name: 'Коментарі звіту',
    eng_name: 'Comments summary',
    children: [
      { name: 'comments_summary', ua_name: 'Коментарі звіту', eng_name: 'Comments summary' },
      { name: 'imsma_comments_summary', ua_name: 'IMSMA коментарі', eng_name: 'IMSMA comments summary' },
      { name: 'status_manually_changed', ua_name: 'Статус', eng_name: 'Manual status' },
      { name: 'display_validation_status', ua_name: 'Статус', eng_name: 'Validation status' },
    ],
  },
];


